import Layout from './Layout'
import Contacts from './Contacts'

export { Layout, Contacts }



// WEBPACK FOOTER //
// ./src/features/Contacts/components/index.js